// src/redux/classSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
 import { add_to_wishlist ,get_wishlist} from "../Service/ApiServices";
import { toast } from "react-toastify";
const initialState = {
  whishlists: [],
  school_id: "",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addloading:false
};


// Async Thunks for API Calls
export const fetchwhishlist = createAsyncThunk(
  "whishlist/fetchwhishlist",
  async ({ page, page_size,school_id,token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_wishlist(page, page_size,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



export const createwhishlist = createAsyncThunk(
  "whishlist/createwhishlist",
  async ({ product_id, school_id, token, signal }, { rejectWithValue }) => {
    try {
        console.log("tockens",token);
      const response = await add_to_wishlist(product_id, school_id, token, signal);
       
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const whishlistSlice = createSlice({
  name: "whishlists",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
 
    setwhishlist(state, action) {
      state.whishlists = action.payload;
    },

    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
 
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
   extraReducers: (builder) => {
    builder
           // Fetch Classes
      .addCase(fetchwhishlist.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchwhishlist.fulfilled, (state, action) => {
        state.loading = false;
        state.whishlists = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchwhishlist.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createwhishlist.pending, (state) => {
             state.addloading = true;
           })
        .addCase(createwhishlist.fulfilled, (state, action) => {
            state.addloading = false;
            toast.success(action?.payload?.message || "Something went wrong!");
        })
        .addCase(createwhishlist.rejected, (state, action) => {
            state.addloading = false;
            state.error = action?.payload?.data?.message;
            const errorMessage = action?.payload?.data?.message || "Something went wrong!";
            toast.info(errorMessage);  
            state.IsEditing = false;
        });
        },
});

// Export the actions and the reducer
export const {
    setActivePage,
    setwhishlist,
    setPageSize,
    setSchoolId

} = whishlistSlice.actions;
export default whishlistSlice.reducer;
